(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["nw-script-pdp-2026"] && !Shopify.designMode) return;
  try {
    // Function to move EasySize button to desired location
function moveEasySizeButton() {
  const easySizeButton = document.querySelector('#easysize_button');
  if (easySizeButton) {
    // Find the parent product form input div
    const parentFormInput = easySizeButton.closest('.product-form__input');
    if (parentFormInput) {
      // Find the target div where we want to move the button
      const targetDiv = parentFormInput.querySelector('.ntg-options-wrap');
      if (targetDiv) {
        // Move the button to the end of the target div
        targetDiv.appendChild(easySizeButton);
        // Clear the interval since we've successfully moved the button
        clearInterval(buttonCheckInterval);
        console.log('EasySize button successfully moved');
      }
    }
  }
}

// Set up an interval to check for the button
const buttonCheckInterval = setInterval(() => {
  moveEasySizeButton();
}, 10); // Check every 10ms

// Set a timeout to stop checking after 10 seconds to prevent infinite polling
setTimeout(() => {
  clearInterval(buttonCheckInterval);
  console.log('Stopped checking for EasySize button after 10 seconds');
}, 10000);
  } catch(e) { console.error(e); }
})();

})();
